/**
 * @file Purchase Album Photos Checkout Success container.
 */

import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { MeQuery } from '../../graphql/queries/account';
import { AlbumDataWithParentAndSubscription } from '../../graphql/queries/albums';
import PurchaseAlbumPhotosCheckoutSuccess from '../../components/purchase/PurchaseAlbumPhotosCheckoutSuccess';

const withUserData = graphql(MeQuery, {
  options: ({ match }) => ({
    variables: {
      albumId: match.params.albumId,
    },
  }),
  props: ({ data: { me, loading } }) => ({
    account: me,
    loading,
  }),
});

const withAlbumData = graphql(AlbumDataWithParentAndSubscription, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumId,
    },
  }),
  props: ({ data: { album } }) => ({
    album,
  }),
});

const mapStateToProps = ({ purchaseAlbumPhotos }) => ({
  purchasedUrl: purchaseAlbumPhotos.purchasedUrl,
});

export default compose(
  withRouter,
  withUserData,
  withAlbumData,
  connect(mapStateToProps, null),
)(PurchaseAlbumPhotosCheckoutSuccess);
